import { Skeleton } from '@/components/ui/skeleton';

import { cn } from '@/lib/utils';

/** Placeholder lines for a panel's content, sized like the rows that replace them. */
export function PanelSkeleton({
    rows = 3,
    className,
    'data-testid': dataTestId,
}: {
    rows?: number;
    className?: string;
    'data-testid'?: string;
}) {
    return (
        <div
            role="status"
            aria-busy="true"
            aria-label="Loading"
            className={cn('flex flex-col gap-3', className)}
            data-testid={dataTestId}
        >
            {Array.from({ length: rows }, (_, i) => (
                <Skeleton key={i} className="h-8 w-full" />
            ))}
        </div>
    );
}

/** Route-level placeholder in the shape of a file or document page: header bar, then a preview pane beside an editor pane. */
export function PageSkeleton({
    'data-testid': dataTestId,
}: {
    'data-testid'?: string;
}) {
    return (
        <main
            role="status"
            aria-busy="true"
            aria-label="Loading"
            className="flex flex-col h-screen bg-white"
            data-testid={dataTestId}
        >
            <div className="flex items-center gap-3 px-6 py-3 border-b shrink-0">
                <Skeleton className="h-4 w-64" />
            </div>
            <div className="flex flex-1 min-h-0 gap-4 p-4">
                <Skeleton className="flex-1" />
                <div className="flex flex-1 flex-col gap-3">
                    <Skeleton className="h-8 w-48" />
                    <Skeleton className="h-8 w-full" />
                    <Skeleton className="h-8 w-full" />
                    <Skeleton className="h-8 w-full" />
                </div>
            </div>
        </main>
    );
}
